//import "jquery-ui/ui/widgets/datepicker";
import './fslightbox/fslightbox';
//import "./../vendor-frontend/jqueryui-timepicker-addon/dist/jquery-ui-timepicker-addon";
import {$window} from "./globals";
import * as FloatLabel from "./floatlabel";
import {debounce} from "lodash-es";

export let do_not_run_after_ajax = false;

export const set_do_not_run_after_ajax = (val) => {
    do_not_run_after_ajax = val;
}

export const Frontend = {
    Init: function () {
        const $document = $(document);
        // ajaxStop zaridi az dojedou vsechny requesty
        // ajaxComplete zaridi po kazdem dojetem requestu
        $document.ajaxStop(function () {
            Frontend.RunAfterAjax();
        });
        $document.on('change','.custom-file-input',function(){
            //get the file name
            const fileName = $(this).val().replace('C:\\fakepath\\', "");
            //replace the "Choose a file" label
            $(this).next('.custom-file-label').html(fileName);
        });

        $.ajaxSetup({
            url: ABSOLUTE_URL + "index.php",
            type: "POST",
            dataType: 'html'
        });

        Frontend.RunAfterAjax();

        if ($(window).width() < 768) {
            FloatLabel.init();
        }
        else {
            FloatLabel.desktop();
        }
        $window.on("resize", debounce(function() {
            if ($window.width() < 768) {
                FloatLabel.init();
            } else {
                FloatLabel.desktop();
            }
        }, 100));
    },

    /**
     * Vrati html pro loadovani
     * @returns {string}
     */
    GetLoadingHtml: function () {
        return '<table height="100%" width="100%">' +
            '<tbody>' +
            '<tr>' +
            '<td valign="middle" align="center">' +
            '<img src="' + ABSOLUTE_URL + 'images/loading.gif">' +
            '</td>' +
            '</tr>' +
            '</tbody>' +
            '</table>';
    },

    processError: function (errorMessage, url, line) {
        alert("Došlo k výjimce v souboru: " + url + "\nna řádku: " + line + "\n\n" + errorMessage);
    },

    RunAfterAjax: function () {
        if (do_not_run_after_ajax) {
            //tohle je kuli tomu, ze kdyz spusti tinymce pomoci inline stylu, tak se pak nesmi spoustet tahle fce...
            do_not_run_after_ajax = false;
            return;
        }

        /*$('input.date').datepicker();
        $('input.datetime').datetimepicker();*/
        $('input.PlusMinusInput').plusMinusInput();

    },
};

$.fn.plusMinusInput = function () {
    const $inputs = this;
    $inputs.each(function () {
        const elements = getElements(this);
        if (!elements) {
            return;
        }

        const $input = elements.input;
        const $minus = elements.minus;
        const $plus = elements.plus;

        const max = parseInt($input.attr('max')) || Number.MAX_VALUE;
        const min = parseInt($input.attr('min')) || Number.MIN_VALUE;
        const step = parseInt($input.attr('step')) || 1;

        let timeout;

        $plus.click(function () {
            const val = parseInt($input.val());
            if (val < max) {
                $input.val(val + step);
            }
            clearTimeout(timeout);
            timeout = setTimeout(function (){
                $input.trigger("change");
            }, 350);
        });

        $minus.click(function () {
            const val = parseInt($input.val());
            if (val > min) {
                $input.val(val - step);
            }
            clearTimeout(timeout);
            timeout = setTimeout(function (){
                $input.trigger('change');
            }, 350);
        });

        $input.data('plus_minus_input', true);
    });
    return this;
};

const getElements = function (input) {
    const $input = $(input);
    if ($input.data('plus_minus_input')) {
        return null;
    }
    const $minusControl = $('<span class="c-cart-table__product-quantity-modifier js-minus">-</span>');
    const $plusControl = $('<span class="c-cart-table__product-quantity-modifier js-plus">+</span>');
    const $plusMinusContainer = $('<div class="plus_minus"></div>');
    $input.wrap($plusMinusContainer);
    $input.before($minusControl);
    $input.after($plusControl);
    return {
        input: $input,
        minus: $minusControl,
        plus: $plusControl,
    };
};

$.urlParam = function(name){
    const results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results==null) {
        return null;
    }
    return decodeURI(results[1]) || 0;
};

if (window.DEBUG_THIS_PROJECT) {
    window.onerror = Frontend.processError;
}